import { render, staticRenderFns } from "./ReqBillingItemsTable.vue?vue&type=template&id=0831347f"
import script from "./ReqBillingItemsTable.vue?vue&type=script&lang=js"
export * from "./ReqBillingItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ReqBillingItemsTable.vue?vue&type=style&index=0&id=0831347f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports